<template>
  <form id="formCostumerData">
    <input id="customerFormId" type="hidden" v-model="formData.id">
    <modal-component id="costumerData" modal-type="modal-lg">
      <template v-slot:title>Dados do Cliente</template>
      <template v-slot:default>
        <!-- toggle search section -->
				<div v-if="modalMode == 'schedule' || modalMode == 'callback'" id="modalCostumerSearch" class="row mb-3">
          <div class="col-12">
            <costumers-select-component id_hidden="costumerId" name_hidden="costumer_id" :disabled="false" :required="true" :readonly="false"></costumers-select-component>
					</div>
        </div>
        <div class="row" id="modalCostumerData">
          <div id="CustomerInfo" class="subSection">
            <span class="subSectionTitle" style="width: 200px">Informações do Cliente</span>
            <div class="inputRow">
              <div class="inputGroup">
                <label for="type">Tipo</label>
                <select name="type" type="text" class="form-control" v-model='formData.type' v-if="!campoVisualizar">
                  <option value="" selected disabled>Selecione...</option>
                  <option value="client">Cliente</option>
                  <option value="lead">Lead</option>
                </select>
								<select name="type" type="text" class="form-control" v-model='formData.type' disabled v-else>
									<option value="" selected disabled>Selecione...</option>
                  <option value="client">Cliente</option>
                  <option value="lead">Lead</option>
								</select>

                <i class="fas fa-asterisk inputIcons"></i>
              </div>
              <div class="inputGroup" style="flex: 2">
                <label for="fantasy-name">Nome Fantasia</label>
                <input name="fantasy-name" type="text" class="form-control" v-model="formData.fantasy_name" v-if="!campoVisualizar">
								<input name="fantasy-name" type="text" class="form-control" v-model="formData.fantasy_name" disabled v-else>
                <i class="fas fa-building inputIcons"></i>
              </div>
              <div class="inputGroup" style="flex: 2">
                <label for="corporate-name">Razão Social</label>
                <input name="corporate-name" type="text" class="form-control" v-model="formData.corporate_name" v-if="!campoVisualizar">
								<input name="corporate-name" type="text" class="form-control" v-model="formData.corporate_name" disabled v-else>
                <i class="fas fa-building inputIcons"></i>
              </div>
            </div>
            <div class="inputRow">
              <div class="inputGroup">
                <label for="cpf-cnpj">CPF/CNPJ</label>
                <input name="cpf-cnpj" type="text" class="form-control" v-model="formData.cnpj" v-mask="['###.###.###-##', '##.###.###/####-##']" v-if="!campoVisualizar">
								<input name="cpf-cnpj" type="text" class="form-control" v-model="formData.cnpj" v-mask="['###.###.###-##', '##.###.###/####-##']" disabled v-else>
                <i class="fas fa-id-card inputIcons"></i>
              </div>
              <div class="inputGroup">
                <label for="manager">Gerente</label>
                <select name="manager" type="text" class="form-control" v-model="formData.manager" v-if="!campoVisualizar">
                  <option value="" selected disabled>Selecione...</option>
                  <option :key="x.id" v-for="x in managerList" v-bind:value="x.id">{{x.name}}</option>
                </select>
								<select name="manager" type="text" class="form-control" v-model="formData.manager" disabled v-else>
                  <option value="" selected disabled>Selecione...</option>
                  <option :key="x.id" v-for="x in managerList" v-bind:value="x.id">{{x.name}}</option>
                </select>
                <i class="fas fa-user-tie inputIcons"></i>
              </div>
              <div class="inputGroup">
                <label for="priority">Prioridade</label>
                <select name="priority" class="form-control" v-model="formData.priority" v-if="!campoVisualizar">
                  <option value="" selected disabled>Selecione...</option>
                  <option value="1">Sim</option>
                  <option value="2">Não</option>
                </select>
								<select name="priority" class="form-control" v-model="formData.priority" disabled v-else>
                  <option value="" selected disabled>Selecione...</option>
                  <option value="1">Sim</option>
                  <option value="2">Não</option>
                </select>
                <i class="fas fa-exclamation inputIcons"></i>
              </div>
							<div class="inputGroup">
								<label for="notify_wpp">Notificar por WhatsApp?</label>
								<select name="notify_wpp" class="form-control" v-model="formData.notify_wpp" v-if="!campoVisualizar">
									<option :value="1">Sim</option>
									<option :value="0">Não</option>
								</select>
								<select name="notify_wpp" class="form-control" v-model="formData.notify_wpp" disabled v-else>
									<option value="1">Sim</option>
									<option value="0">Não</option>
								</select>
								<i class="fa fa-flag inputIcons"></i>
							</div>
							<div class="inputGroup">
                <label for="ip">IP</label>
                <input name="ip" type="text" class="form-control" v-model="formData.ip" v-mask="['###.###.###.###']" v-if="!campoVisualizar">
                <input name="ip" type="text" class="form-control" v-model="formData.ip" v-mask="['###.###.###.###']" disabled v-else>
								<i class="fas fa-asterisk inputIcons"></i>
              </div>
							<div class="inputGroup" v-if="!campoVisualizar">
                <label for="topografia">Topografia</label>
                <file-input-v3
                  id="occurrence"
                  name="occurrence-file"
                  ref="file"
                  icon="fas fa-user-circle"
                  :disabled="false"
                />
                <div v-if="campoVisualizar.toLowerCase() == 'ativar' && dadosTopografia"><button class="btn btn-primary" id="btnOpenFile"  :key="x.id" v-for="x in dadosTopografia" @click.prevent="getFile(x)"><i class="fa fa-file" aria-hidden="true" ></i> Abrir Arquivos...</button></div>
							</div>
							<div class="inputGroup" v-else>
                <label for="topografia">Topografia</label>
                <file-input-v3 v-if="!dadosTopografia"
                  id="occurrence"
                  name="occurrence-file"
                  ref="file"
                  icon="fas fa-user-circle"
                  :disabled="true"
                />
                <div v-if="campoVisualizar.toLowerCase() == 'ativar' && dadosTopografia"><button class="btn btn-primary" id="btnOpenFile"  :key="x.id" v-for="x in dadosTopografia" @click.prevent="getFile(x)"><i class="fa fa-file" aria-hidden="true" ></i> Abrir Arquivos...</button></div>
              </div>
            </div>
          </div>
          <div id="ResponsiblesInfo" class="subSection">
            <span class="subSectionTitle" style="width: 115px">Responsáveis</span>
            <div class="inputRow">
              <div class="responsiblesGroup">
                <select multiple disabled class="form-control">
                  <option v-for="el in formData.clientResponsibles" :key="el.id">{{el.name}} - {{el.email}} / {{formatPhone(el.phone1)}} / {{formatPhone(el.phone2)}}</option>
                </select>
                <i class="fas fa-users inputIcons"></i>
              </div>
              <button type="button" class="btn btn-primary" @click.prevent="editResponsibles(formData.id)" v-if="!campoVisualizar">Editar</button>
							<button type="button" class="btn btn-primary" @click.prevent="editResponsibles(formData.id)" disabled v-else>Editar</button>
						</div>
          </div>

          <div id="AddressInfo" class="subSection">
            <span class="subSectionTitle" style="width: 80px">Endereço</span>
            <div class="inputRow">
              <div class="inputGroup">
                <label for="cep">CEP</label>
								<input name="cep" type="text" class="form-control" v-mask="'##.###-###'" v-model="formData.cep" v-if="!campoVisualizar">
                <input name="cep" type="text" class="form-control" v-mask="'##.###-###'" v-model="formData.cep" disabled v-else>
                <i class="fas fa-map-marker-alt inputIcons"></i>
                <button class="btn" type="button" id="searchCep" @click="buscaCep(formData.cep)" data-toggle="tooltip" data-placement="top" title="Clique para pesquisar o CEP" disabled><i class="fas fa-search-location"></i></button>
              </div>
              <div class="inputGroup">
                <label for="district">Bairro</label>
                <input name="district" type="text" class="form-control" v-model="formData.district" v-if="!campoVisualizar">
								<input name="district" type="text" class="form-control" v-model="formData.district" disabled v-else>
                <i class="fas fa-map inputIcons"></i>
              </div>
              <div class="inputGroup">
                <label for="city">Cidade</label>
                <input name="city" type="text" class="form-control"  v-model="formData.city" v-if="!campoVisualizar">
								<input name="city" type="text" class="form-control"  v-model="formData.city" disabled v-else>
                <i class="fas fa-city inputIcons"></i>
              </div>
              <div class="inputGroup">
                <label for="state">Estado</label>
                <select name="state" type="text" class="form-control"  v-model="formData.state" v-if="!campoVisualizar">
                  <option value="" selected disabled>Selecione...</option>
                  <option v-for="item in statesList" :key="item.id" :value="item.id">{{item.name}}</option>
                </select>
								<select name="state" type="text" class="form-control"  v-model="formData.state" disabled v-else>
                  <option value="" selected disabled>Selecione...</option>
                  <option v-for="item in statesList" :key="item.id" :value="item.id">{{item.name}}</option>
                </select>
                <i class="fas fa-map-marker inputIcons"></i>
              </div>
            </div>
            <div class="inputRow">
              <div class="inputGroup" style="flex: 3">
                <label for="street">Logradouro</label>
                <input name="street" type="text" class="form-control" v-model="formData.street" v-if="!campoVisualizar">
								<input name="street" type="text" class="form-control" v-model="formData.street" disabled v-else>
                <i class="fas fa-map-marked-alt inputIcons"></i>
              </div>
              <div class="inputGroup">
                <label for="number">Número</label>
                <input name="number" type="text" class="form-control" v-model="formData.number" v-if="!campoVisualizar">
								<input name="number" type="text" class="form-control" v-model="formData.number" disabled v-else>
                <i class="fas fa-hashtag inputIcons"></i>
              </div>
              <div class="inputGroup">
                <label for="complement">Complemento</label>
                <input name="complement" type="text" class="form-control" v-model="formData.complement" v-if="!campoVisualizar">
								<input name="complement" type="text" class="form-control" v-model="formData.complement" disabled v-else>
                <i class="fas fa-hashtag inputIcons"></i>
              </div>
            </div>
          </div>
        </div>

      <div style="display: flex; justify-content: center">
        <button id="saveButton" type="submit" class="btn btn-success" @click.prevent="submitForm" v-if="!campoVisualizar">
          <i class="fas fa-save"></i> Salvar
        </button>
        <button id="cancelButton" data-dismiss="modal" type="button" class="btn btn-danger" @click.prevent="closeClient">
          <i class="fas fa-window-close fa-fw"></i> Fechar
        </button>
      </div>
      </template>
    </modal-component>


      <div class="modal fade" tabindex="-1" role="dialog" id="responsiblesModal">
        <div :class="`modal-dialog modal-xl`" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
              <!-- modal title -->
                <slot name="title"></slot>
              </h5>
              <button type="button" class="close" aria-label="Close" @click.prevent="closeResponsibles()">
                <span aria-hidden="true"><i class="fa fa-times"></i></span>
              </button>
            </div>
            <div class="modal-body">
              <div style="max-height: 40vh; overflow: auto">
                <div v-if="formData.clientResponsibles == null" class="row">
                  <div class="column" style="flex: 1">
                    <div style="text-align: center; padding: 20px;">
                      <p style="font-size: 18px"><strong>Aviso: </strong> Não há responsáveis para receber o e-mail...</p>
                      <p style="font-size: 16px">Insira pelo menos um e-mail!</p>
                    </div>
                  </div>
                </div>
                <table v-else class="table" id="responsiblesTable" style="text-align: center">
                  <thead style="font-weight: 700; background-color: lightgray">
                    <th>Nome</th>
                    <th>E-mail</th>
                    <th>Tel 1</th>
                    <th>Tel 2</th>
                    <th>Excluir</th>
                  </thead>
                  <tbody>
                    <tr v-for="el in formData.clientResponsibles" :key="el.id">
                      <td>{{el.name}}</td>
                      <td>{{el.email}}</td>
                      <td>{{formatPhone(el.phone1)}}</td>
                      <td>{{formatPhone(el.phone2)}}</td>
                      <td><button class="btn btn-danger" @click.prevent="removeResponsible(el.email)" style="background: none; border: none; color: red"><i class="fas fa-window-close fa-fw fa-lg"></i></button></td> <!-- Retirar estilos inline e funçao de remover -->
                    </tr>
                  </tbody>
                </table>
              </div>
              <div style="display: flex; justify-content: flex-end">
                <button class="btn btn-secondary" style="margin-right: 30px" @click.prevent="resetResponsibles()"><i class="fas fa-retweet"></i>  Redefinir</button>
              </div>
              <div id="responsiblesForm" class="subSection">
                <span class="subSectionTitle">Adicionar responsável</span>
                <div class="inputRow">
                  <div class="inputGroup">
                    <label for="responsibleName">Nome do Responsável</label>
                    <input name="responsibleName" type="text" class="form-control" v-model="formData.newResponsibleName">
                    <i class="fas fa-user inputIcons"></i>
                  </div>
                  <div class="inputGroup">
                    <label for="responsibleEmail">E-mail</label>
                    <input name="responsibleEmail" type="text" class="form-control" v-model="formData.newResponsibleEmail">
                    <i class="fas fa-at inputIcons"></i>
                  </div>
                </div>
                <div class="inputRow">
                  <div class="inputGroup">
                    <label for="phone1">Telefone 1</label>
                    <input name="phone1" type="text" v-mask="['(##) ####-####', '(##) #####-####']" class="form-control" v-model="formData.newResponsiblePhone1">
                    <i class="fas fa-phone inputIcons"></i>
                  </div>
                  <div class="inputGroup">
                    <label for="phone2">Telefone 2</label>
                    <input name="phone2" type="text" v-mask="['(##) ####-####', '(##) #####-####']" class="form-control" v-model="formData.newResponsiblePhone2">
                    <i class="fas fa-phone inputIcons"></i>
                  </div>
                </div>
                <button class="btn btn-success" type="submit"  @click.prevent="saveResponsible()"><i class="fas fa-plus"></i> Adicionar</button>
              </div>
              <div class="inputRow" style="justify-content: end">
                <button class="btn btn-danger"  style="margin: 3px; line-height: 1" @click.prevent="closeResponsibles()"><i class="fas fa-window-close fa-fw"></i> Fechar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
  </form>
</template>

<script>
import {TheMask} from 'vue-the-mask';
import fileInputV3 from '../newScreen/ordemServico/fileInputV3.vue';

export default {
  components: {
		TheMask,
		fileInputV3
	},
  props: {
    disableInputs: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: "default" //schedule, callback or default
    }
  },
  data() {
    return {
			dadosTopografia: [],
			campoVisualizar: '',
      modalMode: this.mode,
      url: window.location.pathname,
      responsiblesData: [],
      statesList: [],
      managerList: [],
      formData: {
        id: '',
        type: '',
        fantasy_name: '',
        corporate_name: '',
        cnpj: '',
        manager: '',
        priority: '',
        cep: '',
        district: '',
        city: '',
        state: '',
        street: '',
        number: '',
        complement: '',
				topografia: '',
				ip: '',
				notify_wpp: 0,
        newResponsibleName: "",
        newResponsibleEmail: "",
        newResponsiblePhone1: "",
        newResponsiblePhone2: "",
        clientResponsibles: []
      }
    };
  },
  mounted() {
    this.getStatesList();
    this.getManagerList();
		this.$root.$on('tela-visualizar', id =>{
			this.campoVisualizar = "";
      this.campoVisualizar = id;
    });
    this.$root.$on('client-id', id =>{
      if(id){
				this.campoVisualizar = '';
        this.fillClient(id);
      } else {
				this.campoVisualizar = '';
        this.resetClient();
      }
    });
  },

  methods: {
    getStatesList(){
      this.statesList = [
        {id: 'AC', name: 'Acre'},{id: 'AL', name: 'Alagoas'},
        {id: 'AP', name: 'Amapá'},{id: 'AM', name: 'Amazonas'},
        {id: 'BA', name: 'Bahia'},{id: 'CE', name: 'Ceará'},
        {id: 'DF', name: 'Distrito Federal'},{id: 'ES', name: 'Espírito Santo'},
        {id: 'GO', name: 'Goiás'},{id: 'MA', name: 'Maranhão'},
        {id: 'MT', name: 'Mato Grosso'},{id: 'MS', name: 'Mato Grosso do Sul'},
        {id: 'MG', name: 'Minas Gerais'},{id: 'PA', name: 'Pará'},
        {id: 'PB', name: 'Paraíba'},{id: 'PR', name: 'Paraná'},
        {id: 'PE', name: 'Pernambuco'},{id: 'PI', name: 'Piauí'},
        {id: 'RJ', name: 'Rio de Janeiro'},{id: 'RN', name: 'Rio Grande do Norte'},
        {id: 'RS', name: 'Rio Grande do Sul'},{id: 'RO', name: 'Rondônia'},
        {id: 'RR', name: 'Roraima'},{id: 'SC', name: 'Santa Catarina'},
        {id: 'SP', name: 'São Paulo'},{id: 'SE', name: 'Sergipe'},{id: 'TO', name: 'Tocantins'}
      ]
    },

    getManagerList(){
      axios.get("/dialer/allUsers").then(({data}) => {
        this.managerList = data;
      })
    },

    changeMode(data){
      this.modalMode = data;
    },

    async fillClient(client_id){
			this.dadosTopografia = "";
      await axios.get('/clientDetails', {params: {id: client_id}}).then(async data => {
        let details = data.data;
        if(details){
          this.formData.id = details.id;
          this.formData.type = details.client_type;
          this.formData.fantasy_name = details.fantasy_name;
          this.formData.corporate_name = details.corporate_name;
          this.formData.cnpj = details.cpf_cnpj;
          this.formData.manager = details.manager;
          this.formData.priority = details.priority;
          this.formData.cep = details.cep;
          this.formData.district = details.district;
          this.formData.city = details.city;
          this.formData.state = details.uf;
          this.formData.street = details.address;
          this.formData.number = details.number;
          this.formData.complement = details.complement;
					this.formData.topografia = details.topografia;
					this.formData.ip = details.ip;
					this.formData.notify_wpp = details.notify_wpp;

					!details.topografia ? this.dadosTopografia = "" : this.dadosTopografia = JSON.parse(details.topografia);

          await this.getResponsibles(client_id);
        }
      });
    },

		getFile(id){

			let dadoConvertido = id;
			dadoConvertido = dadoConvertido.replace(/\"/g, '');
			dadoConvertido = dadoConvertido.replace(/\[/g, '');
			dadoConvertido = dadoConvertido.replace(/\]/g, '');

			window.open(`/getWalletFile?id=${dadoConvertido}`);

    },

    buscaCep(value){
      //Nova variável "cep" somente com dígitos.
      var cep = value.replace(/\D/g, '');

      if (cep != "") {
          //Expressão regular para validar o CEP.
          var validacep = /^[0-9]{8}$/;
          //Valida o formato do CEP.
          if(validacep.test(cep)) {
            //Preenche os campos com "⏳" enquanto consulta webservice.
            this.formData.district="⏳";
            this.formData.city="⏳";
            this.formData.street="⏳";

            let instance = axios.create();
            delete instance.defaults.headers.common['X-CSRF-TOKEN'];
            delete instance.defaults.headers.common['X-Requested-With'];

            axios.get(`https://viacep.com.br/ws/${ cep }/json/`,)
            .then( ({data}) => {
              if(data.erro != true){
                this.formData.district = data.bairro;
                this.formData.city = data.localidade;
                this.formData.street = data.logradouro;
                this.formData.state = data.uf;
              } else {
                Swal.fire({
                  type: "error",
                  title: "CEP não encontrado!",
                  text: "Por favor, verifique se o CEP digitado está correto.",
                  footer: "Caso o CEP esteja correto e mesmo assim o endereço não for encontrado, insira as informações de endereço do cliente de forma manual."
                })
              }
            })
          } //end if.
          else {
              //cep é inválido.
              limpa_formulário_cep();
              alert("Formato de CEP inválido.");
          }
      } //end if.
      else {
          //cep sem valor, limpa formulário.
          this.resetAddress();
      }
    },

    resetAddress(){
        this.formData.street = '';
        this.formData.district = '';
        this.formData.city = '';
        this.formData.state = ''
    },

    checkForm(){
      if(this.formData.type == ''){
        Swal.fire({
          type: "error",
          title: "Opção não selecionada!",
          text: "Por favor, selecione uma opção no campo TIPO",
        })
        return false;
      } else if(this.formData.fantasy_name == ''){
        Swal.fire({
          type: "error",
          title: "Campo vazio!",
          text: "Por favor, preencha o campo NOME FANTASIA",
        })
        return false;
      } else if(this.formData.corporate_name == ''){
        Swal.fire({
          type: "error",
          title: "Campo vazio!",
          text: "Por favor, preencha o campo RAZÃO SOCIAL",
        })
        return false;
      } else if(this.formData.cnpj == ''){
        Swal.fire({
          type: "error",
          title: "Campo vazio!",
          text: "Por favor, preencha o campo CNPJ",
        })
        return false;
      } else if(this.formData.manager == ''){
        Swal.fire({
          type: "error",
          title: "Opção não selecionada!",
          text: "Por favor, selecione uma opção no campo GERENTE",
        })
        return false;
      } else if(this.formData.priority == ''){
        Swal.fire({
          type: "error",
          title: "Opção não selecionada!",
          text: "Por favor, selecione uma opção no campo PRIORIDADE",
        })
        return false;
      } else if(this.formData.clientResponsibles.length < 1){
        Swal.fire({
          type: "error",
          title: "Não há responsáveis pelo cliente!",
          text: "Por favor, adicione pelo menos um responsável pelo cliente",
          footer: "Para adicionar um responsável, clique no botão EDITAR ao lado do campo RESPONSÁVEIS"
        })
        return false;
      } else if(this.formData.cep == ''){
        Swal.fire({
          type: "error",
          title: "Campo vazio!",
          text: "Por favor, preencha o campo CEP",
        })
        return false;
      } else if(this.formData.district == ''){
        Swal.fire({
          type: "error",
          title: "Campo vazio!",
          text: "Por favor, preencha o campo BAIRRO",
        })
        return false;
      } else if(this.formData.city == ''){
        Swal.fire({
          type: "error",
          title: "Campo vazio!",
          text: "Por favor, preencha o campo CIDADE",
        })
        return false;
      } else if(this.formData.state == ''){
        Swal.fire({
          type: "error",
          title: "Opção não selecionada!",
          text: "Por favor, selecione uma opção no campo ESTADO",
        })
        return false;
      } else if(this.formData.street == ''){
        Swal.fire({
          type: "error",
          title: "Campo vazio!",
          text: "Por favor, preencha o campo LOGRADOURO",
        })
        return false;
      } else if(this.formData.number == ''){
        Swal.fire({
          type: "error",
          title: "Campo vazio!",
          text: "Por favor, preencha o campo NÚMERO",
        })
        return false;
      } else {
        return true;
      }
    },

    async submitForm() {
      if(this.checkForm()){
				let fileInfo = new FormData();
				let fileArquivos = document.getElementById('occurrence-inputfile').files;
				for(let i = 0; i < fileArquivos.length; i++){
						fileInfo.append('occurrenceFile[]', fileArquivos[i]);
				}

        fileInfo.append('data', JSON.stringify(this.formData));

				axios.post('/customer_base/create', fileInfo, {headers: {'Content-Type': 'multipart/form-data'}}).then(({data}) => {
					Swal.fire({
                    type: "success",
                    title: "Feito!",
                    text: "Chamado salvo com sucesso!"
          }).then(result => {
              $('#costumerData').modal('hide');
              location.reload();
            });
				}).catch(error => {
								console.error("Erro ao salvar:", error);
                return Swal.fire({
                    type: "error",
                    title: "Erro!",
                    text: "Falha ao realizar a ação!"
                });
        });
				return;
    	}
    },

    resetClient(){
			this.dadosTopografia = '';
			//this.campoVisualizar = '';
      this.formData = {
        id: '',
        type: '',
        fantasy_name: '',
        corporate_name: '',
        cnpj: '',
        manager: '',
        priority: '',
        cep: '',
        district: '',
        city: '',
        state: '',
        street: '',
        number: '',
        complement: '',
				topografia: '',
				ip: '',
				notify_wpp: 0,
        newResponsibleName: "",
        newResponsibleEmail: "",
        newResponsiblePhone1: "",
        newResponsiblePhone2: "",
        clientResponsibles: []
      }
    },

    editResponsibles(client_id){
      $('#costumerData').modal('hide');
      $('#responsiblesModal').modal('show');
      $('#modalCloseButton').css("display", "none");
    },

    async getResponsibles(client_id){
      if(client_id){
        await axios.get('/customer_base/getResponsibles', {params: {id: client_id}}).then(async data => {
          this.formData.clientResponsibles = data.data;
        });
      }else {
        this.formData.clientResponsibles = [];
      }
    },

    saveResponsible(){
      if(this.formData.newResponsibleEmail == "" || this.formData.newResponsibleEmail.indexOf('@')==-1 || this.formData.newResponsibleEmail.indexOf('.')==-1 )
        {
          Swal.fire({
              type: "error",
              title: "Erro!",
              text: "Digite um e-mail válido!"
          });
        } else {
					this.formData.newResponsibleName = this.formData.newResponsibleName.trim();
					this.formData.newResponsibleEmail = this.formData.newResponsibleEmail.trim();
          this.formData.clientResponsibles.push({
            'id': null,
            'name': (this.formData.newResponsibleName) ? this.formData.newResponsibleName : 'admin',
            'email': this.formData.newResponsibleEmail,
            'phone1': this.formData.newResponsiblePhone1 ? this.formData.newResponsiblePhone1 : '',
            'phone2': this.formData.newResponsiblePhone2 ? this.formData.newResponsiblePhone2 : '',
          });

          Swal.fire({
                  type: "success",
                  title: "Feito!",
                  text: "Responsável adicionado com sucesso!"
              });
          this.formData.newResponsibleName = '';
          this.formData.newResponsibleEmail = '';
          this.formData.newResponsiblePhone1 = '';
          this.formData.newResponsiblePhone2 = '';
          }
      },

    removeResponsible(email){
      let index = this.formData.clientResponsibles.map(function(e) { return e.email; }).indexOf(email);
      this.formData.clientResponsibles.splice(index,1);
    },

    resetResponsibles(){
      axios.get('/customer_base/getResponsibles', {params: {id: this.formData.id}}).then (({data}) => {
        if(data){
          this.formData.clientResponsibles = data;
        }
      });
    },

    closeResponsibles(){
      if(this.formData.clientResponsibles == null || this.formData.clientResponsibles == []){
        Swal.fire({
          type: "error",
          title: "A lista de e-mails está vazia!",
          text: "Insira pelo menos um e-mail válido para continuar."
        })
      } else {
        this.formData.newResponsibleName = '';
        this.formData.newResponsibleEmail = '';
        this.formData.newResponsiblePhone1 = '';
        this.formData.newResponsiblePhone2 = '';
				$('#responsiblesModal').modal('hide');
				$('#costumerData').modal('show');
      }
    },

    closeClient(){
      $('#costumerData').modal('hide');
			this.resetClient();
    },

    formatPhone(phone){
      phone = phone.replace(/\D/g,"");
      phone = phone.replace(/^(\d{2})(\d)/g,"($1) $2");
      phone = phone.replace(/(\d)(\d{4})$/,"$1-$2");
      return phone;
    }
  },

  watch: {

    'formData.id': function(){
    }
  }
};
</script>
<style scoped>
  .inputRow{
    display: flex;
    flex-direction: row;
    justify-content: space-around;
  }

	.fileUpload {
        position: relative;
        overflow: hidden;
        background-color: rgb(28,134,154);
        padding: 10px;
        z-index: 0;
    }
    .fileUpload input.upload {
        position: absolute;
        top: 0;
        right: 0;
        margin: 0;
        padding: 0;
        font-size: 20px;
        cursor: pointer;
        opacity: 0;
        filter: alpha(opacity=0);
        z-index: 0;
    }
  .inputRow button {
    margin: 5px;
  }

  .inputGroup{
    display: flex;
    flex-direction: column;
    flex: 1;
    margin: 5px;
    position: relative;
  }

  .responsiblesGroup{
    display: flex;
    flex-direction: row;
    flex: 1;
    margin: 5px;
    position: relative;
  }

  .inputGroup label {
    font-weight: bold;
    margin: 0;
  }

  .inputGroup input {
    padding-left: 40px;
  }

  .inputGroup select {
    padding-left: 40px;
  }

  .responsiblesGroup select {
    padding-left: 40px;
  }

  .subSection{
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 10px;
    border-radius: 5px;
    background-color: #d3d3d359;
  }

  .subSectionTitle{
    margin-top: -18px;
    margin-left: 20px;
    color: #1c869a;
    font-size: 18px;
    font-weight: bold;
  }

  .inputIcons{
    position: absolute;
    color: #f38630;
    top: 30px;
    left: 10px;
    opacity: 40%;
    padding-right: 10px;
    padding-top: 5px;
    text-align: center;
  }

  #searchCep {
    position: absolute;
    top: 27px;
    margin: 0;
    background-color: white;
    right: 5px;
    color: #1c869a;
    padding: 2px 4px;
    border: 1px solid;
    transition: 0.2s;
  }

  #searchCep:hover{
    background-color: #1c869a;
    color: white;
  }

  #responsiblesTable th {
    border: 1px solid white;
    background-color: rgb(28,134,154);
    color: white;
    vertical-align: middle;
  }

  #responsiblesTable td {
    border: 1px solid lightgray;
    vertical-align: middle;
  }

  #responsiblesModal{
    top: 10%;
  }

  #closeButtonDiv{
    position: absolute;
    width: 100%;
    text-align: end;
  }

  #closeButton {
    margin: 6px;
    background-color: rgba(0,0,0,0);
    color: white;
    border: none;
  }

  #closeButton:hover {
      color: #f38630;
  }

  .row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    align-items: center;
  }

  .modal-responsibles {
    background-color: #fefefe;
    margin: 2% auto; /* 15% from the top and centered */
    padding: 20px;
    border: 1px solid #888;
    width: 50%; /* Could be more or less, depending on screen size */
    height: 40%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  #costumerData{
    top: 10%;
  }

  #saveButton, #cancelButton {
    margin: 3px;
    width: 30%;
  }

</style>
